module.exports = __webpack_public_path__ + "assets/pdf/Webmacherin-Lieferanten-2023.5b1cea4a.pdf";